import { render, staticRenderFns } from "./input_restitusi_kompensasi.vue?vue&type=template&id=15d31430&"
import script from "./input_restitusi_kompensasi.vue?vue&type=script&lang=js&"
export * from "./input_restitusi_kompensasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports